import { GATEWAY_ORIGIN } from '@/constants/environment';

/**
 * PPS API Configuration
 *
 * Package Price Service API provides extras/auxiliary services for a hotel package.
 * Authentication is handled by API Gateway (Login: {} empty object).
 */
export const PPS_CONFIG = {
  ENDPOINT: `${GATEWAY_ORIGIN}/pps`,
  AGENCY_NUMBER: 1,

  TIMEOUT: 20000, // 20 seconds

  RETRY: {
    maxAttempts: 1, // 1 retry = 2 total attempts max (PPS is supplementary)
    initialDelay: 500,
  },
} as const;

export const PPS_ENDPOINTS = {
  GET_EXTRAS: '/GetPackagePricesAndAvailabilitiesV2',
} as const;
